import { first } from 'lodash';
import React, { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useCategories } from '../../../../data/hooks/categories';
import { useConditions } from '../../../../data/hooks/query';
import LayoutColumns from '../../LayoutColumns/LayoutColumns';
import styles from './CategorySelection.module.scss';

function CategorySelection(props) {
    const { onSelect } = props,
        categories = useCategories(),
        conditions = useConditions(),
        dispatch = useDispatch();

    const handleAddCondition = useCallback(
        (categoryId) => {
            onSelect(categoryId);
        },
        [onSelect]
    );

    useEffect(() => {
        if (categories.length == 1) {
            let defaultCategory = first(categories);
            if (defaultCategory) {
                onSelect(defaultCategory.id);
            }
        }
    }, []);

    return (
        <LayoutColumns className={styles.CategorySelection}>
            {categories.map((category, i) => (
                <button key={i} type="button" className={['btn', 'btn-primary', 'btn-lg', styles.category].join(' ')} onClick={() => handleAddCondition(category.id)}>
                    {category.label}
                </button>
            ))}
        </LayoutColumns>
    );
}

export default CategorySelection;
